import * as React from "react";
import PropTypes from "prop-types";
import BooleanItem from "../../internal/BooleanItem";
import FormError from "../../FormError";
import Theme from "../../Theme";

export default class BooleanField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelPositionRight: PropTypes.bool,
    labelHasLink: PropTypes.bool,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    error: PropTypes.string,
    appearance: PropTypes.string,
    labelStyle: PropTypes.object,
    style: PropTypes.object,
  };

  state = {
    value: Boolean(this.props.value),
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value === this.state.value) {
      return;
    }
    let value = nextProps.value === "false" ? false : Boolean(nextProps.value);
    this.setState({ value });
  }

  _handleChange = (isInputChecked) => {
    this.setState({ value: isInputChecked });

    if (!this.props.onChange) {
      return;
    }
    this.props.onChange(isInputChecked);
  };

  render() {
    const {
      name,
      label,
      appearance,
      labelPositionRight,
      labelHasLink,
      error,
      labelStyle,
      style,
    } = this.props;

    const { value } = this.state;

    return (
      <div
        data-component-name="BooleanField"
        data-prop-name={name}
        data-prop-value={value.toString()}
        style={style}
      >
        <FormError error={error}>
          <div style={{ padding: Theme.Padding.CONTENT }}>
            <BooleanItem
              value={value}
              label={label}
              labelPositionRight={labelPositionRight}
              labelHasLink={labelHasLink}
              onChange={this._handleChange}
              appearance={appearance}
              labelStyle={labelStyle}
            />
          </div>
        </FormError>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/BooleanField.jsx